import { Permission } from 'shared'
import CIMSTable from 'components/CIMSTable'
import { useColumns } from './hooks/useColumns'
import { usePhotoFilenamesContext } from './PhotoFilenameContext'
import EditFilenameModal from '../EditFilenameModal'
import { useEditFilenameModal } from '../EditFilenameModal/hooks/useEditFilenameModal'
import { PhotoFilename } from './PhotoFilenameContext/types'
import ModalExample from './components/ModalExample'
import { useEditPhotoFilenameMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'

const PhotoFilenames: React.FC = () => {
  const {
    photoFilenames,
    loading,
    refetch: onReload,
  } = usePhotoFilenamesContext()
  const columns = useColumns()
  const context = useEditFilenameModal<PhotoFilename>()
  const [edit] = useEditPhotoFilenameMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editPhotoFilename: {
        photoFilename: { classType },
      },
    }) => simpleEditNotification(`Filename for ${classType}`),
  })
  return (
    <CIMSTable
      columns={columns}
      records={photoFilenames}
      rowKey="id"
      loading={loading}
      actions={{
        header: { onReload },
        row: {
          edit: {
            permission: Permission.EditFilename,
            modal: {
              type: 'custom',
              toggle: (record) => context.toggle(record),
            },
          },
        },
      }}
    >
      <EditFilenameModal
        context={context}
        type="photo"
        name={(state) => state?.classTypeName}
        edit={async ({ id: classTypeId }, projectId, templateItems) =>
          edit({
            variables: { input: { classTypeId, projectId, templateItems } },
          })
        }
        postEdit={onReload}
      >
        <ModalExample {...context} />
      </EditFilenameModal>
    </CIMSTable>
  )
}

export default PhotoFilenames
